'use client'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <html>
      <body>
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
          <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
            <h2 className="text-2xl font-bold text-red-600 mb-4">
              Error Crítico
            </h2>

            <div className="mb-4">
              <p className="text-gray-600">
                {error.message || 'Ha ocurrido un error crítico'}
              </p>

              {error.digest && (
                <p className="text-sm text-gray-500 mt-2">
                  ID del error: {error.digest}
                </p>
              )}
            </div>

            <button
              onClick={() => reset()}
              className="w-full bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 transition-colors"
            >
              Intentar nuevamente
            </button>
          </div>
        </div>
      </body>
    </html>
  )
} 